import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import { TemplateObjectType } from 'data/templates/api';
// import { SetConditionalVariablesActionPayload } from '../actions';
import { ProjectTemplateStore } from '../types';

export const variablesSlice = {
  setConditionalVariables: (
    state: ProjectTemplateStore,
    { payload }: PayloadAction<any>,
  ): ProjectTemplateStore => {
    const { variableId, formValues, templateType } = payload;
    const path = `data.${state.activeId}.template.templateMeta.conditionalVariables`;
    const _payload = { formValues } as any;

    if (templateType === TemplateObjectType.Project) {
      _payload.recordId = state.activeId;
    }

    return dotPropImmutable.merge(state, path, { [variableId]: _payload });
  },

  removeConditionalVariables: (
    state: ProjectTemplateStore,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { payload }: PayloadAction<any>,
  ): ProjectTemplateStore => {
    // const { variableId } = payload;
    // const path = `data.${state.activeId}.template.templateMeta.conditionalVariables.${variableId}`;

    /**
     * TODO: mark the variable as deleted
     * and unmark the same on undo
     * and on template save, delete the variables marked as deleted
     * before making API call.
     */
    return state;

    // return {
    //   ...state,
    //   ...dotPropImmutable.delete(state, path),
    // };
  },
};
